export const REWARD_RATE = 0.97

// Estimated number of seconds it takes to submit a transaction (3 blocks) in seconds
export const ROUND_BUFFER = 9

export const PAST_ROUND_COUNT = 5
export const FUTURE_ROUND_COUNT = 2

export const ROUNDS_PER_PAGE = 1000
export const LEADERBOARD_MIN_ROUNDS_PLAYED = 10
